import RevampComplete from '../../../assets/img/home/a-completely-revamped.png';

export default function AboutSection() {
  return (
    <>
      <section className="padding-tb-50px sm-ptb-30px" id="about">
        <div className="container">
          <div className="">
            <div className="row">
              <div className="col-md-6 visible-sm">
                <img className="" width="100%" src={RevampComplete} alt="Excellence" />
              </div>
              <div
                className="col-md-6 wow fadeInRight"
                data-wow-duration="1.5s"
                data-wow-offset="10"
              >
                <div className="firo-title dark text-md-right margin-top-120px margin-right-30px margin-right-sm-0px sm-mb-20px sm-mt-30px">
                  <h2 className="title">
                    Experienced Faculties approach to preparation, performance analysis and
                    mentorship
                  </h2>
                  <div className="description line-height-30" />
                  <a href="contact.php" className="firo-bottom sm mt-20">
                    Join the revolution!
                  </a>
                </div>
              </div>
              <div
                className="col-md-6 hidden-sm wow fadeInLeft"
                data-wow-duration="1.5s"
                data-wow-offset="10"
              >
                <img className="" width="100%" src={RevampComplete} alt="Excellence" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
